import { useState } from "react";
import { Link } from "react-router-dom";
import Modal from "react-modal";
import { toast } from "react-toastify";
import joyride from "../../../media/joyride.png";
import "../../../styles/circle.css";
import { useFetch } from "../../../custom/api";
import { toFarsiNumber } from "../../../custom/helpers";

const CircleChart = ({ percentage, color }) => {
  const r = 40;
  const circ = 2 * Math.PI * r;
  const strokePct = ((100 - percentage) * circ) / 100;
  let farsiPercentage = toFarsiNumber(percentage);

  return (
    <div className="single-chart">
      <svg width="100" height="100">
        <g transform="rotate(-90 100 100)">
          <circle
            r={r}
            cx="150"
            cy="50"
            fill="transparent"
            stroke="lightgrey"
            strokeWidth="0.75rem"
          ></circle>
          <circle
            r={r}
            cx="150"
            cy="50"
            fill="transparent"
            stroke={color}
            strokeWidth="0.75rem"
            strokeDasharray={circ}
            strokeDashoffset={strokePct}
          ></circle>
        </g>
        <text
          x="50%"
          y="45%"
          dominantBaseline="central"
          textAnchor="middle"
        >{`${farsiPercentage}%`}</text>
        <text x="50%" y="65%" dominantBaseline="central" textAnchor="middle">
          مانده
        </text>
      </svg>
    </div>
  );
};

const NoSubscription = () => {
  return (
    <div className="grey-1 rightAlign b-grey-5 radius2 padding5 shadow-down">
      <div className="spc-between">
        <div>
          <p className="heading-2 marginBottom0-4r">هنوز اشتراکی نداری!</p>
          <p className="caption-1 yekan">
            تقویم و لیست خرید و کلی برنامه هفتگی پیشنهادی منتظرت هستن!
          </p>
        </div>
        <img src={joyride} alt="printCalendar" />
      </div>
    </div>
  );
};

const ActiveSubscription = ({ active_plan }) => {
  let remainMinutes =
    active_plan.remaining_days * 24 * 60 +
    active_plan.remaining_hours * 60 +
    active_plan.remaining_minutes;
  let totalMinutes = active_plan.total_days * 24 * 60;
  let percentMinutes = remainMinutes / totalMinutes;
  let percentage = percentMinutes * 100;

  let color;
  if (percentage < 14) {
    color = "#ff6d6d";
  } else if (percentage < 28) {
    color = "#f29c23";
  } else {
    color = "#7579e7";
  }

  let farsiDays = toFarsiNumber(active_plan.remaining_days);
  let farsiHours = toFarsiNumber(active_plan.remaining_hours);
  let farsiMinutes = toFarsiNumber(active_plan.remaining_minutes);

  return (
    <div className="grey-1 rightAlign b-grey-5 radius2 padding5 shadow-down">
      <div className="spc-between">
        <div>
          <p className="heading-2 marginBottom0-4r">وضعیت اشتراک فعال</p>
          <p className="caption-1 yekan">
            <span style={{ color: color }}> {farsiDays} </span>
            روز و<span style={{ color: color }}> {farsiHours} </span>
            ساعت و<span style={{ color: color }}> {farsiMinutes} </span>
            دقیقه از اشتراک شما باقی مانده است
          </p>
        </div>
        <CircleChart
          percentage={percentage.toFixed(0)}
          color={color}
        ></CircleChart>
      </div>
    </div>
  );
};

const PlanModal = ({
  priceAfterDiscount,
  planInfo,
  showPlanModal,
  setShowPlanModal,
  handleSubmit,
  loading,
}) => {
  return (
    <>
      <Modal
        ariaHideApp={false}
        isOpen={showPlanModal}
        onRequestClose={(e) => {
          setShowPlanModal(false);
        }}
        contentLabel="Date Picker Modal"
        className="modal"
        overlayClassName="overlay"
      >
        <div className="modal-header-dark">
          <Link
            to=""
            onClick={(e) => {
              setShowPlanModal(false);
            }}
          >
            <span className="icon-iconclose rectangle2 b-grey-1 heading-1"></span>
          </Link>
        </div>
        <div className="modal-body-dark white">
          <div>
            {planInfo.type === "free" && (
              <div className="marginBottom3 centerd">
                <span className="icon-icongift white big-0 yellow-1"></span>
              </div>
            )}
            <p className="heading-1 centerd">{planInfo.name}</p>
            <p className="caption-1 yekan grey-3">{planInfo.description}</p>
            {planInfo.type !== "free" && (
              <div className="b-white padding10 radius2 marginUpDown10 shadow-purple">
                {planInfo.price > 0 && (
                  <p className="heading-3 grey-2 lineThrough">{`قیمت کل ${toFarsiNumber(
                    planInfo.price
                  )} هزار تومان`}</p>
                )}
                {planInfo.discount_percent > 0 && (
                  <p className="heading-3 grey-2">{`با ${toFarsiNumber(
                    planInfo.discount_percent
                  )}% تخفیف`}</p>
                )}
                {planInfo.discount_amount > 0 && (
                  <p className="heading-3 grey-2">{`با ${toFarsiNumber(
                    planInfo.discount_amount
                  )} هزار تومان تخفیف`}</p>
                )}
                {planInfo.gift_days > 0 && (
                  <p className="heading-3 grey-2">{`${toFarsiNumber(
                    planInfo.gift_days
                  )} روز اشتراک هدیه`}</p>
                )}
                {/* {planInfo.gift_coins > 0 && <p className="heading-3 grey-2">{`${toFarsiNumber(planInfo.gift_coins)} سکه`}</p>} */}
                {priceAfterDiscount !== "-1" && (
                  <p className="heading-1 purple-1 marginTop5">{`${toFarsiNumber(
                    priceAfterDiscount
                  )} هزار تومان`}</p>
                )}
              </div>
            )}

            {planInfo.once && (
              <p className="subject-2 yekan yellow-2 margin marginBottom5">
                فقط حواست باشه که از این بسته فقط یکبار میتونی استفاده کنی!
              </p>
            )}
          </div>
          {planInfo.type === "free" && (
            <FreeModalFooter
              setShowModal={setShowPlanModal}
              handleSubmit={handleSubmit}
            ></FreeModalFooter>
          )}
          {planInfo.type === "premium" && (
            <PaidModalFooter
              price={priceAfterDiscount}
              handleSubmit={handleSubmit}
              loading={loading}
            ></PaidModalFooter>
          )}
        </div>
      </Modal>
    </>
  );
};

const FreeModalFooter = ({ setShowModal, handleSubmit }) => {
  return (
    <div className="modal-footer">
      <Link
        to="/"
        onClick={handleSubmit}
        className="marginBottom0-4r fill-container heading-3 b-yellow-0 radius1-5"
      >
        فعال میکنم
      </Link>

      <Link
        to=""
        onClick={(e) => {
          setShowModal(false);
        }}
        className="marginBottom0-4r b-grey-1 grey-3 fill-container heading-3 radius1-5"
      >
        منصرف شدم
      </Link>
    </div>
  );
};

const PaidModalFooter = ({ price, handleSubmit, loading }) => {
  console.log("sssssssssssssssss");
  return (
    <div className="modal-footer">
      <button
        onClick={handleSubmit}
        disabled={loading}
        className="marginBottom0-4r heading-3 fill-container b-purple-1 radius1-5"
      >
        {loading
          ? "در حال پردازش..."
          : `پرداخت ${toFarsiNumber(price)} هزار تومان`}
      </button>
    </div>
  );
};

const PlanFace = ({ planInfo, setActivePlan }) => {
  const [showPlanModal, setShowPlanModal] = useState(false);
  const { myFetch } = useFetch();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();
    const r = await myFetch("activate-plan", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ plan_id: planInfo.plan_id }),
    });
    const jsonResponse = await r.json();

    if (jsonResponse.status === "success") {
      toast.success(jsonResponse.message);
      setTimeout(() => {
        window.location.assign(jsonResponse.url);
      }, 3000);
    } else {
      toast.error(jsonResponse.message);
    }
    setLoading(false);
  };

  let priceAfterDiscount;
  if (planInfo.discount_amount > 0) {
    priceAfterDiscount = planInfo.price - planInfo.discount_amount;
  } else if (planInfo.discount_percent > 0) {
    priceAfterDiscount =
      planInfo.price - planInfo.price * (planInfo.discount_percent / 100);
  } else {
    priceAfterDiscount = -1;
  }
  priceAfterDiscount = priceAfterDiscount.toFixed(0);

  return (
    <>
      <PlanModal
        priceAfterDiscount={priceAfterDiscount}
        planInfo={planInfo}
        showPlanModal={showPlanModal}
        setShowPlanModal={setShowPlanModal}
        handleSubmit={handleSubmit}
        loading={loading}
      ></PlanModal>

      <div
        className={`white b-grey-1 radius2 padding5 marginTop10 ${
          planInfo.price < 150
            ? "shadow-silver"
            : planInfo.price > 300
            ? "shadow-silver"
            : "shadow-yellow"
        }`}
        onClick={(e) => {
          setShowPlanModal(true);
        }}
      >
        {planInfo.type === "free" && (
          <div className="inline">
            <div>
              <span className="icon-icongift white big-1 yellow-1"></span>
            </div>
          </div>
        )}

        <p className="marginBottom0-4r yekan yellow-1">{planInfo.name}</p>
        {planInfo.discount_percent > 0 && (
          <p className="green-1 yekan">{`با ${toFarsiNumber(
            planInfo.discount_percent
          )}% تخفیف`}</p>
        )}
        {planInfo.price > 0 && (
          <p className="heading-1 white">{`ماهانه ${toFarsiNumber(
            parseInt(priceAfterDiscount / (planInfo.duration_days / 30))
          )} هزار تومان`}</p>
        )}
        {/* {priceAfterDiscount !== '-1' && <p className="heading-2 white">{`${toFarsiNumber(priceAfterDiscount)} هزار تومان`}</p>} */}
        {planInfo.gift_days > 0 && (
          <p className="subject-1 yekan yellow-1 marginUpDown5">
            {`${toFarsiNumber(planInfo.gift_days)} روز اشتراک هدیه`}{" "}
          </p>
        )}
        {/* + ${toFarsiNumber(planInfo.gift_coins)} سکه */}
        <div>
          {planInfo.once && (
            <p className="subject-1 yellow-1 marginBottom3">یکبار مصرف</p>
          )}
        </div>
      </div>
    </>
  );
};

export { NoSubscription, PlanFace, ActiveSubscription };
